export const usePLPGridLayout = (
    type?: 'p40productListPage' | 'p41productListPage' | 'm170searchPage'
) => {
    switch (type) {
        case 'p41productListPage':
            return 'full';
        default:
            return 'with-menu';
    }
};
